module.exports = __webpack_public_path__ + "img/rancher-logo.66cf5910.svg";